import { getURLParameter } from "../../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import AbstractCommand from "../../../../../../shared/src/ranj/app/core/AbstractCommand";
import SkinKeys from "../../../../../../shared/src/ranj/app/ui/SkinKeys";
import SaveModel from "../model/SaveModel";
import GameFlowEvent from "./GameFlowEvent";


export default class StartGameCommand extends AbstractCommand {

    /**
     * @param {soma.EventDispatcher} dispatcher 
     * @param {SaveModel} saveModel 
     */
    constructor(dispatcher, saveModel) {
        super(dispatcher);

        this.execute = function(event) {

            if (saveModel.getSaveGame() || getURLParameter("skiptutorial")=="1") {
                this.dispatch(GameFlowEvent.INTRO_COMPLETED);
            } else {
                this.gotoScreen(SkinKeys.INTRO_SCREEN);
            }
        };

    }

}